import { createContext } from 'react';
export const CommercialMessagesContext = createContext(undefined);
//# sourceMappingURL=context.js.map